import axios from 'axios';
import swal from "sweetalert";
import {
 loginConfirmedAction,
 Logout,
} from '../store/actions/AuthActions';
import { LOGIN_CONFIRMED_ACTION, LOGOUT_ACTION } from '../store/actions/AuthActions';
import { mapUiRole } from "../utils/mapUiRole";
import { getPermissionNames } from "../utils/permissions";
export function signUp(name, email, mobile, password ) {
 const postData = {
 name,
 email,
 mobile,
 password
 
 };
 
 return axios.post(
 `${process.env.REACT_APP_API_URL}/api/auth/register`,
 postData
 );
}


export function login(email, password) {
 const postData = {
 email,
 password,
 returnSecureToken: true,
 };
 return axios.post(
 `${process.env.REACT_APP_API_URL}/api/auth/login`,
 postData
);

}

export function formatError(errorResponse) {
 const message =
 errorResponse?.error?.message || 
 errorResponse?.message || // Common REST API errors
 'UNKNOWN_ERROR';

 switch (message) {
 case 'EMAIL_EXISTS':
 swal("Oops", "Email already exists", "error");
 break;
 case 'EMAIL_NOT_FOUND':
 swal("Oops", "Email not found", "error", { button: "Try Again!" });
 break;
 case 'INVALID_PASSWORD':
 swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
 break;
 case 'USER_DISABLED':
 swal("Oops", "User Disabled", "error");
 break;
 default:
 swal("Oops", message, "error"); // show backend message
 break;
 }
}


export function saveTokenInLocalStorage(tokenDetails) {
 // Default expiration: 30 days if expiresIn is missing
 const expiresInMs = tokenDetails.expiresIn
 ? tokenDetails.expiresIn * 1000
 : 30 * 24 * 60 * 60 * 1000;

 tokenDetails.expireDate = new Date(new Date().getTime() + expiresInMs);

 localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, navigate, timer) {
 if (!timer || timer <= 0) return;

 setTimeout(() => {
 dispatch(Logout(navigate));
 }, timer);
}



export const checkAutoLogin = async (dispatch, navigate) => {
 const token = localStorage.getItem("token");
 if (!token) {
 dispatch({ type: LOGOUT_ACTION });
 return false;
 }

 try {
 // Re-fetch fresh user data on refresh
 const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
 headers: { Authorization: `Bearer ${token}` }
 });

 if (res.data?.success) {
 const userData = res.data.data;
 const uiRole = mapUiRole(userData.role);

 const permissionNames = getPermissionNames(userData);

 const updatedDetails = {
 ...userData,
 permissionNames,
 uiRole,
 token // keep token in the object if expected by other parts
 };

 localStorage.setItem("userDetails", JSON.stringify(updatedDetails));

 dispatch({
 type: LOGIN_CONFIRMED_ACTION,
 payload: {
 token,
 user: updatedDetails,
 },
 });
 return true;
 }
 } catch (err) {
 console.error("Auto-login fetch error:", err);
 // If token is invalid or server is down, we might want to logout or just fail silently
 // dispatch({ type: LOGOUT_ACTION }); 
 }

 // Fallback to local data if fetch fails but we have a token
 const userDetails = localStorage.getItem("userDetails")
 ? JSON.parse(localStorage.getItem("userDetails"))
 : null;

 if (userDetails) {
 const uiRole = mapUiRole(userDetails.role);
 dispatch({
 type: LOGIN_CONFIRMED_ACTION,
 payload: {
 token,
 user: { ...userDetails, uiRole },
 },
 });
 return true;
 }

 dispatch({ type: LOGOUT_ACTION });
 return false;
};
